<template>
    <div>
        <form data-vv-scope="phone">
            <div v-for="(phone,p) in phones" v-bind:key="p" class="flex flex-col md:flex-row justify-between items-start">
                <div class="flex flex-col w-full">
                    <MultiselectCustom endpoint="user/phone-types/"
                        :disabled="disabled"
                        :placeholder="`${ $t('phone_type') }`"
                        v-validate="'required'"
                        v-model="phone.phone_type"
                        :name="'phone_type'+p"
                        />
                    <span
                        class="text-danger text-sm"
                        v-if="
                            errors.has('phone_type'+p,'phone')
                        "
                    >
                        {{$t('names_for_validate.valid_phone_type')}}
                    </span>
                </div>
                <div class="flex flex-col w-full">

                    <vs-input :label-placeholder="`${ $t('phone_number') }*`"
                        v-validate="'required|min:18'"
                        :name="'phone_number_'+p"
                        :disabled="disabled"
                        v-model="phone.value"
                        v-mask="'+7 (###) ### ## ##'"
                        class="mt-8 flex-auto p-1 w-full"/>

                    <span
                        class="text-danger text-sm"
                        v-if="
                            errors.has('phone_number_'+p,'phone')
                        "
                    >
                        {{$t('names_for_validate.valid_phone_number')}}
                    </span>
                </div>

            </div>

        </form>
        <vs-row class="justify-between">
            <div class="flex flex-row justify-start"> </div>
            <vs-row class="justify-end">
                <vx-tooltip  :text="$t('remove')">
                    <vs-button
                        color="danger"
                        type="border"
                        icon-pack="feather"
                        icon="icon-minus"
                        class="m-1"
                        @click="popIphones()"
                        v-if="phones.length > 1"
                        >
                    </vs-button>
                </vx-tooltip>
                <vx-tooltip :text="$t('add')">
                    <vs-button
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="m-1"
                        @click="pushIphones()"
                        >
                    </vs-button>
                </vx-tooltip>
            </vs-row>

        </vs-row>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import {mask, masked} from 'vue-the-mask'
export default {
    name: "Phone",
    components: {
        MultiselectCustom,
        ValidateText
    },
    directives: {
        mask,
        masked
    },
    props: {
        data: {
            type: Array,
            default:[],
        },
        applicantNoProfileUid: {
            type: String,
            default: null,
        },
        profileUid: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        }
    },
    data(){
        return {
            phones: [

            ],
        }
    },
    methods: {
        async  validateStep(val){
            return this.$validator.validateAll('phone').then(async (result) => {
                if (result){
                    this.$vs.loading();
                    try {
                        await  this.initProfileId(this.profileUid,this.phones)
                        this.phones.forEach(async phone=>{
                            phone.profile = val
                            const response = (await this.$http[phone.uid ? 'put' : 'post'](
                                `admissions/phones/${phone.uid?phone.uid+'/':''}`,
                                {
                                    ...phone,
                                    ...(this.applicantNoProfileUid && { applicant: this.applicantNoProfileUid}),
                                }
                            )).data;
                            phone.uid = response.uid
                        })
                        return true
                    } catch (e){
                        return false
                    } finally {
                        this.$vs.loading.close();
                    }
                } else {
                    return false
                }
            })
        },

        initProfileId(id,array){
            array.forEach(element => {
                element.profile = id
            });
        },

        pushIphones(){
            this.phones.push({
                phone_type: '',
                value: '',
                profile: "",
                uid: null
            })
        },

        popIphones(){
            if(this.phones.length>1){
                this.phones.pop();
            }
        }

    },
    created() {
        if (this.data){
            this.data.forEach(data => {
                this.phones.push(data);
            });
        }else{
            this.pushIphones();
        }
    }
}
</script>

<style scoped lang="scss">

</style>
